import { useEffect, useState } from 'react';
import { clienteService, documentoService, garantiaService, prestamoService } from '../services/api';
import '../styles/Documentos.css';

const Documentos = () => {
  const [tipoDocumento, setTipoDocumento] = useState('');
  const [clientes, setClientes] = useState([]);
  const [prestamos, setPrestamos] = useState([]);
  const [garantias, setGarantias] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState('');
  const [garantiaSeleccionada, setGarantiaSeleccionada] = useState('');
  const [cargando, setCargando] = useState(false);

  // Estados para autocomplete
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);

  // Helpers para obtener objetos completos
  const cliente = clientes.find(c => c.id === parseInt(clienteSeleccionado));
  const prestamo = prestamos.find(p => p.id === parseInt(prestamoSeleccionado));
  const garantia = garantias.find(g => g.id === parseInt(garantiaSeleccionada));

  const tiposDocumentos = [
    { id: 'testigos', nombre: 'Testigos', icono: '👥' },
    { id: 'pagare_notarial', nombre: 'Pagaré Notarial', icono: '📝' },
    { id: 'entrega_voluntaria', nombre: 'Entrega Voluntaria', icono: '🤝' },
    { id: 'debo_pagare', nombre: 'Debo y Pagaré', icono: '💰' },
    { id: 'intimidacion', nombre: 'Intimidación de Pago', icono: '⚠️' },
    { id: 'carta_saldo', nombre: 'Carta de Saldo', icono: '📄' },
    { id: 'contrato_bluetooth', nombre: 'Contrato Bluetooth', icono: '📱' }
  ];

  useEffect(() => {
    // Verificar token al cargar
    const token = localStorage.getItem('token');
    console.log('Verificando token al cargar página:', token ? 'PRESENTE' : 'AUSENTE');

    if (!token) {
      alert('⚠️ Sesión expirada. Redirigiendo al login...');
      window.location.href = '/login';
      return;
    }

    cargarDatos();
  }, []);

  // Click fuera del dropdown para cerrarlo
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.selector-con-busqueda')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (clienteSeleccionado) {
      cargarPrestamosCliente();
      cargarGarantiasCliente();
    } else {
      setPrestamos([]);
      setGarantias([]);
      setPrestamoSeleccionado('');
      setGarantiaSeleccionada('');
    }
  }, [clienteSeleccionado]);

  const cargarDatos = async () => {
    try {
      console.log('Cargando clientes...');
      const response = await clienteService.getAll({ per_page: 1000 });
      console.log('Respuesta de clientes:', response.data);
      setClientes(response.data.clientes || []);
      console.log('Clientes cargados:', response.data.clientes?.length || 0);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      alert('❌ Error al cargar clientes: ' + (error.response?.data?.message || error.message));
    }
  };

  const cargarPrestamosCliente = async () => {
    try {
      console.log('Cargando préstamos para cliente:', clienteSeleccionado);
      const response = await prestamoService.getAll({
        cliente_id: clienteSeleccionado,
        per_page: 1000
      });
      console.log('Respuesta de préstamos:', response.data);
      setPrestamos(response.data.prestamos || []);
      console.log('Préstamos cargados:', response.data.prestamos?.length || 0);
    } catch (error) {
      console.error('Error al cargar préstamos:', error);
      setPrestamos([]);
    }
  };

  const cargarGarantiasCliente = async () => {
    try {
      console.log('Cargando garantías para cliente:', clienteSeleccionado);
      const response = await garantiaService.getAll({
        cliente_id: clienteSeleccionado,
        per_page: 1000
      });
      console.log('Respuesta de garantías:', response.data);
      setGarantias(response.data.garantias || []);
      console.log('Garantías cargadas:', response.data.garantias?.length || 0);
    } catch (error) {
      console.error('Error al cargar garantías:', error);
      setGarantias([]);
    }
  };

  // Función de filtrado de clientes
  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    const nombreCompleto = `${cliente.nombres} ${cliente.apellidos}`.toLowerCase();
    const cedula = cliente.cedula?.toLowerCase() || '';
    const apodo = cliente.apodo?.toLowerCase() || '';
    const id = cliente.id?.toString() || '';

    return (
      cliente.nombres?.toLowerCase().includes(termino) ||
      cliente.apellidos?.toLowerCase().includes(termino) ||
      cedula.includes(termino) ||
      apodo.includes(termino) ||
      nombreCompleto.includes(termino) ||
      id.includes(termino)
    );
  }).slice(0, 10);

  // Seleccionar cliente desde el autocomplete
  const seleccionarCliente = (cliente) => {
    console.log('Cliente seleccionado:', cliente.id);
    setClienteSeleccionado(cliente.id.toString());
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setPrestamoSeleccionado('');
    setGarantiaSeleccionada('');
  };

  // Limpiar selección de cliente
  const limpiarCliente = () => {
    setClienteSeleccionado('');
    setClienteObj(null);
    setBusquedaCliente('');
    setPrestamos([]);
    setGarantias([]);
    setPrestamoSeleccionado('');
    setGarantiaSeleccionada('');
  };

    const handleGenerarDocumento = async () => {
    if (!clienteSeleccionado) {
      alert('Por favor selecciona un cliente');
      return;
    }

    // Debug: verificar token
    const token = localStorage.getItem('token');
    console.log('Token disponible:', token ? 'Sí' : 'No');
    console.log('Token length:', token?.length || 0);

    if (!token) {
      alert('⚠️ No hay token de autenticación. Por favor, inicia sesión nuevamente.');
      // Redirigir al login
      window.location.href = '/login';
      return;
    }

    setCargando(true);
    try {
      const data = {
        tipo_documento: tipoDocumento,
        cliente_id: clienteSeleccionado,
        prestamo_id: prestamoSeleccionado,
        garantia_id: garantiaSeleccionada
      };

      const response = await documentoService.generar(data);

      // Determinar nombre del archivo según tipo de documento
      const nombresArchivos = {
        testigos: 'testigos.pdf',
        pagare_notarial: 'pagare_notarial.pdf',
        entrega_voluntaria: 'entrega_voluntaria.pdf',
        debo_pagare: 'debo_pagare.pdf',
        intimidacion: 'intimidacion_pago.pdf',
        carta_saldo: 'carta_saldo.pdf',
        contrato_bluetooth: 'contrato_bluetooth.pdf'
      };

      const nombreArchivo = nombresArchivos[tipoDocumento] || 'documento.pdf';

      // Descargar el PDF
      documentoService.descargar(response.data, nombreArchivo);

      alert('✅ Documento generado exitosamente');

      // Resetear formulario
      setTipoDocumento('');
      setClienteSeleccionado('');
      setPrestamoSeleccionado('');
      setGarantiaSeleccionada('');
      setPrestamos([]);
      setGarantias([]);

    } catch (error) {
      console.error('Error al generar documento:', error);

      let mensaje = '❌ Error al generar el documento: ';

      if (error.response?.status === 401) {
        mensaje += 'No autorizado. Por favor, inicia sesión nuevamente.';
        // Limpiar token inválido
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } else if (error.response?.status === 500) {
        mensaje += 'Error interno del servidor. ' + (error.response?.data?.error || 'Contacta al administrador.');
      } else {
        mensaje += error.response?.data?.error || error.message;
      }

      alert(mensaje);
    } finally {
      setCargando(false);
    }
  };

  const getClienteInfo = () => {
    const cliente = clientes.find(c => c.id === parseInt(clienteSeleccionado));
    return cliente;
  };

  const getPrestamoInfo = () => {
    const prestamo = prestamos.find(p => p.id === parseInt(prestamoSeleccionado));
    return prestamo;
  };

  const getGarantiaInfo = () => {
    const garantia = garantias.find(g => g.id === parseInt(garantiaSeleccionada));
    return garantia;
  };

  // Vista principal con grid de documentos
  if (!tipoDocumento) {
    return (
      <div className="documentos-container">
        <div className="documentos-header">
          <h1>📄 Generación de Documentos</h1>
          <p>Seleccione el tipo de documento que desea generar</p>
        </div>

        <div className="documentos-grid">
          {tiposDocumentos.map(tipo => (
            <div
              key={tipo.id}
              className="documento-card"
              onClick={() => setTipoDocumento(tipo.id)}
            >
              <div className="documento-icono">{tipo.icono}</div>
              <h3>{tipo.nombre}</h3>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Vista de formulario según el tipo de documento
  const tipoActual = tiposDocumentos.find(t => t.id === tipoDocumento);

  return (
    <div className="documentos-container">
      <div className="documentos-header">
        <h1>{tipoActual?.icono} {tipoActual?.nombre}</h1>
        <button onClick={() => {
          setTipoDocumento('');
          setClienteSeleccionado('');
          setPrestamoSeleccionado('');
          setGarantiaSeleccionada('');
        }} className="btn-secondary">
          ← Volver
        </button>
      </div>

      <div className="formulario-documento">
        {/* Selector de Cliente con Autocomplete */}
        <div className="form-section">
          <h3>👤 Cliente</h3>
          <div className="form-group">
            <label>Buscar Cliente * ({clientes.length} clientes disponibles)</label>
            <div className="selector-con-busqueda" style={{position: 'relative', width: '100%'}}>
              <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                <input
                  type="text"
                  value={busquedaCliente}
                  onChange={(e) => {
                    setBusquedaCliente(e.target.value);
                    setMostrarDropdown(true);
                  }}
                  onFocus={() => setMostrarDropdown(true)}
                  placeholder="Escribe nombre, cédula, apodo o ID..."
                  className="input-select"
                  style={{flex: 1}}
                />
                {clienteSeleccionado && (
                  <button
                    onClick={limpiarCliente}
                    style={{
                      padding: '8px 12px',
                      backgroundColor: '#e53e3e',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                    title="Limpiar selección"
                  >
                    ✕
                  </button>
                )}
              </div>

              {mostrarDropdown && busquedaCliente && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  maxHeight: '400px',
                  overflowY: 'auto',
                  zIndex: 1000,
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  marginTop: '4px'
                }}>
                  {clientesFiltrados.length > 0 ? (
                    clientesFiltrados.map((cliente) => {
                      const fotoUrl = cliente.foto_url;
                      const nombreCompleto = `${cliente.nombres} ${cliente.apellidos}`;
                      const iniciales = `${cliente.nombres?.[0] || ''}${cliente.apellidos?.[0] || ''}`.toUpperCase();

                      return (
                        <div
                          key={cliente.id}
                          onClick={() => seleccionarCliente(cliente)}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f7fafc'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                          style={{
                            padding: '12px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #eee',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                          }}
                        >
                          {/* Foto o Avatar con iniciales */}
                          {fotoUrl ? (
                            <img
                              src={fotoUrl}
                              alt={nombreCompleto}
                              style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                objectFit: 'cover'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextElementSibling.style.display = 'flex';
                              }}
                            />
                          ) : null}
                          <div
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              backgroundColor: '#4299e1',
                              color: 'white',
                              display: fotoUrl ? 'none' : 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              fontSize: '14px'
                            }}
                          >
                            {iniciales}
                          </div>

                          {/* Información del cliente */}
                          <div style={{flex: 1}}>
                            <div style={{fontWeight: '500', color: '#2d3748'}}>
                              {nombreCompleto}
                            </div>
                            <div style={{fontSize: '0.9rem', color: '#718096'}}>
                              {cliente.cedula}
                              {cliente.apodo && ` • ${cliente.apodo}`}
                              {` • ID: ${cliente.id}`}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{padding: '12px', color: '#718096', textAlign: 'center'}}>
                      No se encontraron clientes
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {cliente && (
            <div className="cliente-info">
              <p><strong>Nombre:</strong> {cliente.nombres} {cliente.apellidos}</p>
              <p><strong>Cédula:</strong> {cliente.cedula}</p>
              <p><strong>Teléfono:</strong> {cliente.telefono || 'N/A'}</p>
              <p><strong>Dirección:</strong> {cliente.direccion || 'N/A'}</p>
            </div>
          )}
        </div>

        {/* Selector de Préstamo (si aplica) */}
        {clienteSeleccionado && ['pagare_notarial', 'entrega_voluntaria', 'debo_pagare', 'intimidacion', 'carta_saldo', 'testigos'].includes(tipoDocumento) && (
          <div className="form-section">
            <h3>💰 Préstamo</h3>
            <div className="form-group">
              <label>Seleccionar Préstamo</label>
              <select
                value={prestamoSeleccionado}
                onChange={(e) => setPrestamoSeleccionado(e.target.value)}
                className="input-select"
              >
                <option value="">--- Seleccione un préstamo ---</option>
                {prestamos
                  .filter(p => {
                    // Para carta de saldo, solo mostrar préstamos cancelados/saldados
                    if (tipoDocumento === 'carta_saldo') {
                      return p.estado === 'cancelado' || p.estado === 'saldado';
                    }
                    // Para intimidación de pago, solo mostrar préstamos atrasados
                    if (tipoDocumento === 'intimidacion') {
                      return p.estado === 'atrasado' || p.estado === 'moroso';
                    }
                    // Para otros documentos, mostrar todos los préstamos
                    return true;
                  })
                  .map(p => (
                    <option key={p.id} value={p.id}>
                      Préstamo #{p.id} - RD$ {p.monto_prestado?.toLocaleString()} - {p.modalidad} - {p.estado}
                    </option>
                  ))}
              </select>
              {prestamos.length === 0 && clienteSeleccionado && (
                <p style={{color: '#e53e3e', fontSize: '0.9rem', marginTop: '0.5rem'}}>
                  ℹ️ Este cliente no tiene préstamos registrados
                </p>
              )}
              {prestamos.length > 0 && tipoDocumento === 'carta_saldo' && !prestamos.some(p => p.estado === 'cancelado' || p.estado === 'saldado') && (
                <p style={{color: '#e53e3e', fontSize: '0.9rem', marginTop: '0.5rem'}}>
                  ℹ️ Este cliente no tiene préstamos cancelados/saldados
                </p>
              )}
              {prestamos.length > 0 && tipoDocumento === 'intimidacion' && !prestamos.some(p => p.estado === 'atrasado' || p.estado === 'moroso') && (
                <p style={{color: '#e53e3e', fontSize: '0.9rem', marginTop: '0.5rem'}}>
                  ℹ️ Este cliente no tiene préstamos atrasados
                </p>
              )}
            </div>

            {prestamo && (
              <div className="prestamo-info">
                <p><strong>Monto:</strong> RD$ {prestamo.monto_prestado?.toLocaleString()}</p>
                <p><strong>Total:</strong> RD$ {prestamo.total?.toLocaleString()}</p>
                <p><strong>Modalidad:</strong> {prestamo.modalidad}</p>
                <p><strong>Cuotas:</strong> {prestamo.cuotas_pagadas || 0}/{prestamo.cuotas}</p>
                <p><strong>Estado:</strong> {prestamo.estado}</p>
              </div>
            )}
          </div>
        )}

        {/* Selector de Garantía (si aplica) */}
        {clienteSeleccionado && ['entrega_voluntaria', 'contrato_bluetooth'].includes(tipoDocumento) && (
          <div className="form-section">
            <h3>📦 Garantía</h3>
            <div className="form-group">
              <label>Seleccionar Garantía</label>
              <select
                value={garantiaSeleccionada}
                onChange={(e) => setGarantiaSeleccionada(e.target.value)}
                className="input-select"
              >
                <option value="">--- Seleccione una garantía ---</option>
                {garantias.map(g => (
                  <option key={g.id} value={g.id}>
                    {g.categoria} - {g.producto_tipo || 'N/A'} - RD$ {g.valor_estimado?.toLocaleString() || '0'}
                  </option>
                ))}
              </select>
              {garantias.length === 0 && clienteSeleccionado && (
                <p style={{color: '#e53e3e', fontSize: '0.9rem', marginTop: '0.5rem'}}>
                  ℹ️ Este cliente no tiene garantías registradas
                </p>
              )}
            </div>

            {garantia && (
              <div className="garantia-info">
                <p><strong>Categoría:</strong> {garantia.categoria}</p>
                <p><strong>Producto:</strong> {garantia.producto_tipo || 'N/A'}</p>
                <p><strong>Marca/Modelo:</strong> {garantia.marca || 'N/A'} {garantia.modelo || ''}</p>
                <p><strong>Valor:</strong> RD$ {garantia.valor_estimado?.toLocaleString() || '0'}</p>
                <p><strong>Estado:</strong> {garantia.estado || 'N/A'}</p>
              </div>
            )}
          </div>
        )}

        {/* Información adicional según tipo de documento */}
        {tipoDocumento === 'contrato_bluetooth' && cliente && (
          <div className="form-section">
            <h3>📱 Información del Contrato</h3>
            <div className="alert alert-info">
              ℹ️ Este contrato solo se imprime desde un teléfono Android.
            </div>
          </div>
        )}

        {/* Avisos según el tipo de documento */}
        {tipoDocumento === 'pagare_notarial' && (
          <div className="avisos-section">
            <div className="aviso aviso-notario">
              <h4>⚠️ Aviso Notario</h4>
              <p>COMPLETE LA INFORMACIÓN REQUERIDA ANTES DE CONTINUAR:</p>
              <ol>
                <li>Debe registrar su dirección.</li>
                <li>Debe registrar su abogado notario.</li>
              </ol>
            </div>
          </div>
        )}

        {/* Botón de generación */}
        <div className="form-actions">
          <button
            onClick={handleGenerarDocumento}
            className="btn-primary btn-generar"
            disabled={cargando || !clienteSeleccionado}
          >
            {cargando ? 'Generando...' : `Generar ${tipoActual?.nombre}`}
          </button>

          {/* Debug info */}
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '4px'}}>
            <strong>Estado del sistema:</strong><br />
            • Clientes cargados: {clientes.length}<br />
            • Cliente seleccionado: {clienteSeleccionado || 'NINGUNO'}<br />
            • Estado de carga: {cargando ? 'CARGANDO' : 'LISTO'}<br />
            • Token de sesión: {localStorage.getItem('token') ? '✅ PRESENTE' : '❌ AUSENTE'}<br />
            • Botón habilitado: {(!cargando && clienteSeleccionado) ? '✅ SÍ' : '❌ NO'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentos;